import React, {ReactElement, useMemo} from 'react'
import {Lang} from 'yougile-lang'
import {cn} from '@containers/html-utils'
import {PageService} from '@extensions/page-service'
import {useMailSettings} from './hooks'

export const MailSettingsPage = (): ReactElement => {
  const {email, key} = useMemo(() => {
    return {
      email: PageService.getSearchParam('email'),
      key: PageService.getSearchParam('key')
    }
  }, [])

  const {
    loaded,
    saving,
    save,
    settings,
    changed,
    toggleNews,
    toggleNotify,
    setNotifyFrequency
  } = useMailSettings(email, key)

  if (!loaded) {
    return <div className="loading" />
  }

  const saveClassName = cn(
    '_button',
    'msp-save',
    (!changed || saving) && 'disabled'
  )
  const frequencyClassName = cn(
    'msp-notifications',
    !settings.notifications && 'disabled'
  )

  return (
    <div className="msp">
      <a className="msp-logo" href="/" />
      <div className="msp-wnd">
        <div className="msp-header">
          {Lang.msg.mailSettingsHead}
          <span className="font-semibold"> {email}</span>
        </div>
        <div className="msp-line" />
        <div className="msp-form">
          <label className="msp-item">
            <input
              type="checkbox"
              className="_checkbox"
              checked={settings.news}
              onChange={toggleNews}
            />
            <span className="_checkbox" />
            {Lang.msg.mspGetNews}
          </label>
          <label className="msp-item">
            <input
              type="checkbox"
              className="_checkbox"
              checked={settings.notifications}
              onChange={toggleNotify}
            />
            <span className="_checkbox" />
            {Lang.msg.mspGetNotifications}
          </label>
          <form className={frequencyClassName}>
            <label className="msp-option">
              <input
                name="notifications"
                type="radio"
                value={Lang.msg.mspNotifyOften}
                checked={settings.frequency === 'often'}
                onChange={() => setNotifyFrequency('often')}
              />
              {Lang.msg.mspNotifyOften}
            </label>
            <label className="msp-option">
              <input
                name="notifications"
                type="radio"
                checked={settings.frequency === '1h'}
                onChange={() => setNotifyFrequency('1h')}
              />
              {Lang.msg.mspNotifyHourly}
            </label>
            <label className="msp-option">
              <input
                name="notifications"
                type="radio"
                checked={settings.frequency === '24h'}
                onChange={() => setNotifyFrequency('24h')}
              />
              {Lang.msg.mspNotifyDaily}
            </label>
          </form>
        </div>

        <div className={saveClassName} onClick={save}>
          {Lang.msg.save}
        </div>
      </div>
    </div>
  )
}
